export const fetchSelectedIssueData = () => {
    return {
        type: 'FETCH_SELECTED_ISSUE_DATA'
    }
}